import { memberCalls2Url } from '@helpers'
import type { TTinyCustomer, TTinyCustomerResponse } from '@/core/types'

/**
 * Fetch customer info by customer ID
 * API: GET https://member-calls2.unicity.com/h/info/[customer-id]
 * Returns partial customer data (TTinyCustomer)
 */
export const fetchCustomerById = async (customerId: TTinyCustomer['unicity']): Promise<TTinyCustomer> => {
    // USHOP-2914: isCheckEarlyBird=1 makes BE return isCanBuyEarlyBird on the customer
    // (true only if joined <=30 days AND hasn't already bought an early-bird ticket).
    const url = memberCalls2Url({ path: `/h/info/${customerId}?expand=allx&isCheckEarlyBird=1` })

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })

    if (!response.ok) {
        throw new Error(`Failed to fetch customer: ${response.status} ${response.statusText}`)
    }

    const data: TTinyCustomerResponse = await response.json()

    const customer = data.items?.[0]

    if (!customer) {
        throw new Error('Customer not found')
    }

    return customer
}
